import { render, staticRenderFns } from "./DmhFaqs.vue?vue&type=template&id=a6195efa"
import script from "./DmhFaqs.vue?vue&type=script&lang=js"
export * from "./DmhFaqs.vue?vue&type=script&lang=js"
import style0 from "./DmhFaqs.vue?vue&type=style&index=0&id=a6195efa&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports